import { API_URL } from './../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage
} from './../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject,
    API_URL,
};

export const GET_BEHAVIOR_CATEGORY_LIST_API = `${API_URL}/api/MasterBehaviorCategory/GetMasterBehaviorCategory`;
export const POST_BEHAVIOR_CATEGORY_API = `${API_URL}/api/MasterBehaviorCategory/SaveMasterBehaviorCategory`;
export const GET_BEHAVIOR_CATEGORY_DETAILS_API = `${API_URL}/api/MasterBehaviorCategory/GetMasterbehaviorCategoryById`;
export const DELETE_BEHAVIOR_CATEGORY_API = `${API_URL}/api/MasterBehaviorCategory/DeleteMasterBehaviorCategory`;

export const BehaviorCategoryActionTypes = {
  get_behaviorCategoryList: createRequestActionTypes('GET_BEHAVIORCATEGORYLIST'),
  post_behaviorCategory: createRequestActionTypes('POST_BEHAVIORCATEGORY'),
  get_behaviorCategoryDetails: createRequestActionTypes('GET_BEHAVIORCATEGORYDETAILS'),
  delete_behaviorCategory: createRequestActionTypes('DELETE_BEHAVIORCATEGORY'),
};

export const MODULE = 'DCMASTER_BEHAVIORCATEGORY';





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/behaviourCategory/constants/ApiConstants.js